import React, { useEffect, useState } from "react";
import Popup from "../ui/Popup";
import Menu from "../ui/Menu";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";

export const phone_types = [
    { value: "", label: "N/A"},
    { value: "Cel", label: "Cel" },
    { value: "Hom", label: "Hom" },
    { value: "Wrk", label: "Wrk" },
    { value: "Fax", label: "Fax" },
    { value: "Celx", label: "Celx" },
]

export default function PhoneType(props) {
    const { controller = "", callback = () => { }, value = "", route = "" } = props;
    const [selected, setSelected] = useState(phone_types.find(item => item.value === value)?.value || "Cel");

    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.ENTER, action: () => { callback(selected) } }
    ]
    
    useEffect(() => {
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER]);
        return cleanup;
    }, [actions])

    const menu = phone_types.map(item => {
        let _i = { ...item };
        _i.text = _i.label;
        _i.action = () => callback(_i.value);
        return _i;
    })

    return (
        <>
            <Popup 
                title={"Phone Type"} 
                width={"auto"} 
                callback={callback} 
                component={
                    <Menu 
                        controller={controller} 
                        height = {240}
                        keyName="value" 
                        route={route} 
                        menu={menu} 
                        selected={selected} 
                        setSelected={setSelected} 
                        callback={(e) => callback(e.value)} 
                    />} 
            />
        </>)
}